<template>
    <div class="v-overview">
        <Header></Header>
        <Navigation></Navigation>
        <div class="v-overview__content container">
            <div class="flex-row">
                <div class="flex-col">
                    <div>
                        <overviewSummary></overviewSummary>
                        <div class="flex-row flex-row--end">
                                <button class="btn btn--primary" v-on:click="sendLead()">Potwierdź wizytę</button>
                                <h4 v-if="errorMsg">
                                    {{ errorMsg }}
                                </h4>
                        </div>
                    </div>
                </div>
                <div class="flex-col flex-col--4 ml--3">
                    <Summary></Summary>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>

    import Footer from '@/components/footer.vue'
    import Header from '@/components/header.vue'
    import Navigation from "@/components/navigation";

    import overviewSummary from "@/components/overview/summary";

    import Summary from "@/components/services/summary"

    import {mapActions,mapGetters} from "vuex"

    export default {
        data(){
            return{
                errorMsg:false
            }
        },
        components:{
            Footer,
            Header,
            Navigation,
            Summary,
            overviewSummary
        },
        computed:{
            ...mapGetters({
                getLeadResponse:'lead/getLeadResponse'
            })
        },
        methods:{
            ...mapActions({
                sendLead:'lead/sendLead'
            })
        },
        watch:{
            getLeadResponse: {
                handler(){
                    if(this.getLeadResponse && this.getLeadResponse.status != 200){
                        this.errorMsg = this.getLeadResponse.error
                    }else{
                        this.$router.push({ path: 'success' })
                    }
                },
                deep:true
            }
        }
    }
</script>
<style lang="scss">
    .v-overview{
        &__content{
            min-height: 90vh;
        }
    }
</style>